import React, { useRef, useEffect, useState } from "react";
import { Modal, Input, Button } from "antd";
import { useLanguage } from "../../context/LanguageContext";

export default function ForgotPasswordModal({
  open,
  onClose,
  step,
  email,
  setEmail,
  code,
  setCode,
  newPassword,
  setNewPassword,
  loading,
  onSendResetCode,
  onResetPassword,
  onResendCode,
}) {
  const { t } = useLanguage();
 useEffect(() => {
  if (open) {
    setCode(""); // يمسح الكود كل مرة المودال يفتح
  }
}, [open]);

  const codeRefs = useRef([]);
  const codeArray = code.split("").slice(0, 6);

  const [resendLoading, setResendLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(60);

  useEffect(() => {
    
    if (open && step === 2) {
      setTimeout(() => {
        codeRefs.current[0]?.focus();
      }, 100);
    }
  }, [open, step]);

  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);

  useEffect(() => {
    if (!open) {
      setResendCooldown(0);
      setResendLoading(false);
    }
  }, [open]);

  const handleCodeChange = (value, index) => {
    const codeChars = code.split("");
    codeChars[index] = value.slice(-1);
    const newCode = codeChars.join("").padEnd(6, "");
    setCode(newCode);
    if (value && index < 5) codeRefs.current[index + 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    const key = e.key;
    if (key === "Backspace" && !code[index] && index > 0) {
      const codeChars = code.split("");
      codeChars[index - 1] = "";
      setCode(codeChars.join(""));
      setTimeout(() => codeRefs.current[index - 1]?.focus(), 60);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").trim().slice(0, 6);
    if (/^\d+$/.test(paste)) {
      setCode(paste.padEnd(6, ""));
      setTimeout(() => codeRefs.current[paste.length - 1]?.focus(), 60);
    }
  };

  const handleResendCode = async () => {
    setResendLoading(true);
    try {
      await onResendCode();
      setResendCooldown(60);
    } catch (error) {
      // Error handled by parent
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={t("forgot_password.title")}
      centered
      bodyStyle={{ padding: "24px" }}
      destroyOnClose
    >
      <div className="space-y-4">
        {step === 1 ? (
          <>
            <div className="text-gray-600 mb-4">
              {t("forgot_password.enter_email_instruction")}
            </div>
            <Input
              type="email"
              placeholder={t("forgot_password.email_placeholder")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              type=""
              loading={loading}
              onClick={onSendResetCode}
              className={`w-full ${
                !email.trim()
                  ? "bg-gray-200"
                  : "bg-primary text-white hover:bg-textPrimary"
              }`}
              disabled={!email.trim()}
            >
              {loading ? t("forgot_password.sending") : t("forgot_password.send_code")}
            </Button>
          </>
        ) : (
          <>
            <div className="text-gray-600 mb-4">
              {t("forgot_password.enter_code_instruction")} {email}
            </div>

            <div className="flex gap-2 justify-center mb-4" onPaste={handlePaste}>
              {Array.from({ length: 6 }).map((_, index) => (
                <Input
                  key={index}
                  ref={(el) => (codeRefs.current[index] = el)}
                  maxLength={1}
                  value={codeArray[index] || ""}
                  onChange={(e) => handleCodeChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="w-10 text-center"
                  size="large"
                  autoComplete="one-time-code"
                />
              ))}
            </div>

            {/* Resend Code Section */}
            <div className="flex justify-center mb-4">
              <Button
                type=""
                onClick={handleResendCode}
                loading={resendLoading}
                disabled={resendCooldown > 0 || resendLoading}
                className="p-0 text-primary hover:text-textPrimary"
              >
                {resendCooldown > 0
                  ? t("forgot_password.resend_in", { seconds: resendCooldown })
                  : resendLoading
                  ? t("forgot_password.sending")
                  : t("forgot_password.resend_code")}
              </Button>
            </div>

            <Input.Password
              placeholder={t("forgot_password.new_password_placeholder")}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <Button
              type=""
              loading={loading}
              onClick={onResetPassword}
              className={`w-full ${
                !code.trim()
                  ? "bg-gray-200"
                  : "bg-primary text-white hover:bg-textPrimary"
              }`}
              disabled={!code.trim()}
            >
              {loading ? t("forgot_password.resetting") : t("forgot_password.reset_button")}
            </Button>
          </>
        )}
      </div>
    </Modal>
  );
}
